import jwt_decode from 'jwt-decode';
const jwtEncode = require('jwt-encode');

export const getLocalUser = (localKey) => getDecryptedLocalData(localKey);

// Get Decrypted Local Data
export const getDecryptedLocalData = (localKey) => {
  // Guard against SSR environments where `window` is not defined.
  if (typeof window === 'undefined') {
    return null;
  }

  const localEncryptedData = localStorage.getItem(localKey);

  // If no data is found for the key, return null.
  if (!localEncryptedData) {
    return null;
  }

  try {
    // Attempt to decode the data.
    return decodeLocalData(localEncryptedData);
  } catch (error) {
    // This error can occur if the token is malformed or invalid.
    console.error(
      `Failed to decode token from localStorage for key "${localKey}". Removing the invalid item.`,
      error
    );
    // Remove the corrupted/invalid data to prevent this error on subsequent loads.
    localStorage.removeItem(localKey);
    return null;
  }
};

// Set Encrypted Local Data
export const setEncryptedLocalData = (data, localKey, secretKey) => {
  // Guard against SSR environments.
  if (typeof window === 'undefined') {
    return;
  }
  const encryptedData = encodeLocalData(data, secretKey);
  localStorage.setItem(localKey, encryptedData);
};

// Encode Local Data
export const encodeLocalData = (data, secret) => jwtEncode(data, secret);

// Decode Local Data
export const decodeLocalData = (encryptedData) => jwt_decode(encryptedData);
